import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../components/BrandMark';
import { defaultLandingLocale, landingLocales } from '../locales/landing';

const FREELANCE_DOCUMENT_NUMBER = 'FL-213753559';
const FREELANCE_DOCUMENT_VERIFICATION_URL =
  process.env.REACT_APP_FREELANCE_DOCUMENT_VERIFICATION_URL || 'أدخل رابط التحقق الخاص بك هنا';

const styles = `
.wl-landing{--primary:#6C3FC5;--primary-dark:#4E2D9A;--primary-light:#8B5CF6;--paper:#fff;--ink:#1A1040;--muted:#655783;--soft:#F5F0FF;--line:#E8E0F7;background:#fff;color:var(--ink);overflow-x:hidden;scroll-behavior:smooth;font-family:system-ui,-apple-system,"Segoe UI",Tahoma,Arial,sans-serif}
.wl-landing *{box-sizing:border-box}.wl-landing a{text-decoration:none}.wl-container{max-width:1200px;margin-inline:auto;width:100%}
.wl-nav{position:fixed;inset-block-start:0;inset-inline:0;z-index:100;padding-inline:5%;height:72px;display:flex;align-items:center;justify-content:space-between;background:rgba(255,255,255,.86);backdrop-filter:blur(22px);border-block-end:1px solid rgba(232,224,247,.75);transition:box-shadow .25s}
.wl-nav.wl-scrolled{box-shadow:0 8px 36px rgba(108,63,197,.12)}.wl-nav-logo,.wl-footer-logo{display:flex;align-items:center;gap:10px;color:var(--ink)}.wl-nav-logo-icon,.wl-footer-logo-icon{width:42px;height:42px;display:flex;align-items:center;justify-content:center;flex-shrink:0}.wl-brand-mark{width:100%;height:100%;object-fit:contain}.wl-nav-logo-text,.wl-footer-logo-text{font-weight:900}.wl-nav-logo-text span{display:block;font-size:10px;color:var(--muted);font-weight:600}
.wl-nav-links{display:flex;align-items:center;gap:26px;list-style:none}.wl-nav-links a{font-size:14px;font-weight:700;color:var(--muted)}.wl-nav-links a:hover{color:var(--primary)}
.wl-nav-actions{display:flex;align-items:center;gap:10px}.wl-lang-switch{border:1.5px solid var(--line);background:#fff;color:var(--primary);border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;font-weight:900;cursor:pointer}.wl-lang-switch:hover{border-color:var(--primary);background:var(--soft)}
.wl-nav-cta,.wl-nav-login,.wl-btn-primary,.wl-btn-secondary,.wl-btn-white,.wl-btn-outline-white,.wl-price-btn{font:inherit;font-weight:900;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;gap:8px;transition:all .2s;cursor:pointer}
.wl-nav-cta,.wl-btn-primary{background:var(--primary);color:#fff;border:none;box-shadow:0 10px 24px rgba(108,63,197,.25)}.wl-nav-cta{padding:9px 20px;font-size:14px}.wl-btn-primary{padding:14px 28px}.wl-nav-cta:hover,.wl-btn-primary:hover{background:var(--primary-dark);transform:translateY(-2px)}
.wl-nav-login{background:#fff;color:var(--primary);border:1.5px solid #D4C3FF;padding:8px 16px;font-size:14px}.wl-nav-login:hover{background:var(--soft);border-color:var(--primary);transform:translateY(-2px)}
.wl-btn-secondary{background:transparent;color:var(--primary);border:1.5px solid #D4C3FF;padding:13px 24px}.wl-btn-secondary:hover{background:var(--soft);border-color:var(--primary)}
.wl-hamburger{display:none;flex-direction:column;gap:5px;padding:6px;background:none;border:none;cursor:pointer}.wl-hamburger span{width:24px;height:2px;background:var(--ink);border-radius:2px}
.wl-mobile-menu{display:none;position:fixed;inset-block-start:72px;inset-inline:0;background:#fff;border-block-end:1px solid var(--line);padding:20px 5%;flex-direction:column;gap:14px;z-index:99}.wl-mobile-menu.wl-open{display:flex}.wl-mobile-menu a{font-weight:800;color:var(--ink);padding-block:8px;border-block-end:1px solid var(--line)}.wl-mobile-menu-actions{display:flex;flex-direction:column;gap:10px;padding-block-start:4px}.wl-mobile-menu .wl-lang-switch{align-self:flex-start}.wl-mobile-menu .wl-nav-login,.wl-mobile-menu .wl-nav-cta{width:100%;padding:12px 16px;border-block-end:0}.wl-mobile-menu .wl-nav-cta{color:#fff}.wl-mobile-menu .wl-nav-login{color:var(--primary)}
.wl-hero{min-height:100vh;padding:132px 5% 90px;display:flex;align-items:center;background:radial-gradient(circle at 12% 8%,rgba(108,63,197,.12),transparent 28%),linear-gradient(155deg,#F5F0FF 0%,#fff 58%,#EDE5FF 100%);position:relative;overflow:hidden}.wl-hero-inner{display:grid;grid-template-columns:1fr 1fr;gap:64px;align-items:center}.wl-hero-badge{display:inline-flex;align-items:center;gap:8px;background:#EDE5FF;color:var(--primary);padding:6px 15px;border-radius:999px;font-size:12px;font-weight:900;margin-block-end:22px;border:1px solid #D4C3FF}.wl-hero-badge:before{content:'';width:7px;height:7px;background:var(--primary);border-radius:50%;animation:wl-pulse 2s infinite}@keyframes wl-pulse{0%,100%{opacity:1}50%{opacity:.35}}
.wl-hero h1{font-size:clamp(2.1rem,4.4vw,3.6rem);font-weight:900;line-height:1.12;margin-block-end:20px}.wl-hero h1 span{color:var(--primary)}.wl-hero-sub{font-size:1.06rem;color:var(--muted);line-height:1.9;margin-block-end:34px;max-width:560px}.wl-hero-btns{display:flex;align-items:center;gap:14px;flex-wrap:wrap}.wl-hero-trust{display:flex;align-items:center;gap:9px;margin-block-start:28px;font-size:13px;color:var(--muted)}.wl-stars,.wl-testimonial-stars{color:#F59E0B;letter-spacing:2px}
.wl-hero-visual{position:relative}.wl-mockup{background:#fff;border-radius:24px;padding:22px;box-shadow:0 24px 70px rgba(108,63,197,.2);border:1px solid var(--line);animation:wl-float 4s ease-in-out infinite}@keyframes wl-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}.wl-mockup-bar{display:flex;gap:8px;margin-block-end:18px}.wl-mockup-dot{width:10px;height:10px;border-radius:50%}.wl-mockup-metrics{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;margin-block-end:14px}.wl-mockup-metric,.wl-mockup-chart{background:var(--soft);border-radius:14px;padding:14px;border:1px solid var(--line)}.wl-mockup-metric-val{font-size:1.5rem;font-weight:900;color:var(--primary)}.wl-mockup-metric-label{font-size:11px;color:var(--muted);margin-block-start:3px}.wl-chart-bars{display:flex;align-items:flex-end;gap:6px;height:64px}.wl-chart-bar{flex:1;background:#D4C3FF;border-radius:6px 6px 0 0}.wl-chart-bar.wl-active{background:var(--primary)}
.wl-mockup-card{background:linear-gradient(135deg,var(--primary),var(--primary-light));border-radius:18px;padding:18px;color:#fff;margin-block-start:12px}.wl-mockup-card-name{font-size:12px;opacity:.82}.wl-mockup-card-title{font-size:15px;font-weight:900;margin-block:4px 10px}.wl-mockup-stamps{display:flex;gap:5px}.wl-mockup-stamp{width:20px;height:20px;border-radius:50%;border:1.5px solid rgba(255,255,255,.55)}.wl-mockup-stamp.wl-filled{background:#fff}
.wl-float-badge{position:absolute;background:#fff;border-radius:14px;padding:10px 13px;box-shadow:0 10px 30px rgba(108,63,197,.13);border:1px solid var(--line);font-size:12px;font-weight:900;color:var(--ink);display:flex;align-items:center;gap:7px}.wl-float-badge.wl-top{inset-block-start:-16px;inset-inline-start:22px}.wl-float-badge.wl-bottom{inset-block-end:24px;inset-inline-start:-24px}.wl-dot{width:8px;height:8px;border-radius:50%;background:#10B981;flex-shrink:0}
.wl-stats{background:var(--primary);padding:44px 5%}.wl-stats-inner{display:grid;grid-template-columns:repeat(4,1fr);gap:18px}.wl-stat{text-align:center;padding:18px}.wl-stat-val{font-size:2rem;font-weight:900;color:#fff}.wl-stat-label{font-size:13px;color:rgba(255,255,255,.76);margin-block-start:4px}.wl-stat+.wl-stat{border-inline-start:1px solid rgba(255,255,255,.22)}
.wl-section{padding:96px 5%;scroll-margin-top:88px}.wl-section-soft{background:var(--soft)}.wl-section-label{text-align:center;color:var(--primary);font-size:12px;font-weight:900;letter-spacing:2px;text-transform:uppercase;margin-block-end:12px}.wl-section-title{text-align:center;font-size:clamp(1.7rem,3vw,2.5rem);font-weight:900;margin-block-end:14px}.wl-section-sub{text-align:center;color:var(--muted);line-height:1.8;max-width:620px;margin:0 auto 54px}
.wl-grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}.wl-grid-4{display:grid;grid-template-columns:repeat(4,1fr);gap:18px}.wl-feature-card,.wl-card-type,.wl-testimonial,.wl-price-card{background:#fff;border:1px solid var(--line);border-radius:20px;padding:28px;transition:all .25s;position:relative;overflow:hidden}.wl-feature-card:hover,.wl-card-type:hover,.wl-testimonial:hover,.wl-price-card:hover{transform:translateY(-5px);box-shadow:0 18px 54px rgba(108,63,197,.16)}.wl-feature-icon,.wl-card-type-icon{width:54px;height:54px;background:var(--soft);border-radius:16px;display:flex;align-items:center;justify-content:center;font-size:1.55rem;margin-block-end:16px}.wl-feature-title,.wl-card-type-title,.wl-step-title{font-size:16px;font-weight:900;margin-block-end:8px}.wl-feature-desc,.wl-card-type-desc,.wl-step-desc,.wl-industry-hint{font-size:13px;color:var(--muted);line-height:1.75}.wl-card-type{text-align:center}.wl-card-type-icon{width:72px;height:72px;border-radius:50%;margin-inline:auto}.wl-card-type-badge,.wl-card-type-example,.wl-price-note,.wl-billing-save-badge{display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:var(--soft);border:1px solid #D4C3FF;color:var(--primary);font-size:11px;font-weight:900;padding:6px 12px}.wl-card-type-example{border-style:dashed;margin-block-start:16px}
.wl-industry-card{background:var(--soft);border:1px solid var(--line);border-radius:18px;padding:24px 18px;text-align:center;transition:all .25s}.wl-industry-card:hover{background:#EDE5FF;border-color:var(--primary);transform:translateY(-4px)}.wl-industry-icon{font-size:2.2rem;margin-block-end:12px}.wl-industry-name{font-size:14px;font-weight:900;margin-block-end:6px}
.wl-steps{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}.wl-step{text-align:center}.wl-step-num{width:74px;height:74px;background:var(--primary);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:1.7rem;color:#fff;margin:0 auto 18px;box-shadow:0 10px 24px rgba(108,63,197,.28);border:5px solid #fff}
.wl-billing-toggle{display:flex;align-items:center;justify-content:center;gap:12px;margin-block-end:34px;flex-wrap:wrap}.wl-billing-label{font:inherit;font-size:13px;font-weight:800;color:var(--muted);cursor:pointer;background:none;border:0;padding:4px}.wl-billing-label.wl-billing-active{color:var(--ink)}.wl-toggle-switch{width:46px;height:26px;background:#D4C3FF;border:0;padding:0;border-radius:999px;cursor:pointer;position:relative;transition:background .2s}.wl-toggle-switch.wl-on{background:var(--primary)}.wl-toggle-switch::after{content:'';position:absolute;inset-block-start:3px;inset-inline-start:3px;width:20px;height:20px;background:#fff;border-radius:50%;transition:transform .2s;box-shadow:0 2px 6px rgba(0,0,0,.18)}.wl-toggle-switch.wl-on::after{transform:translateX(20px)}[dir="rtl"] .wl-toggle-switch.wl-on::after{transform:translateX(-20px)}
.wl-price-card{display:flex;flex-direction:column}.wl-price-card.wl-featured{border-color:var(--primary);background:linear-gradient(145deg,#4E2D9A,#6C3FC5 56%,#8B5CF6);color:#fff;box-shadow:0 24px 70px rgba(108,63,197,.28);transform:translateY(-10px)}.wl-price-card.wl-featured:hover{transform:translateY(-14px)}.wl-price-popular{position:absolute;inset-block-start:0;inset-inline-start:50%;transform:translateX(-50%);background:#FDE68A;color:#4E2D9A;font-size:11px;font-weight:900;padding:6px 18px;border-radius:0 0 10px 10px}.wl-price-name{font-size:15px;font-weight:900;color:var(--primary);margin-block-end:7px}.wl-price-featured .wl-price-name,.wl-featured .wl-price-name{color:#fff}.wl-price-desc{font-size:13px;color:var(--muted);line-height:1.7;min-height:44px}.wl-featured .wl-price-desc{color:rgba(255,255,255,.78)}.wl-price-was{font-size:12px;color:#aaa;text-decoration:line-through;min-height:18px;margin-block-start:12px}.wl-featured .wl-price-was{color:rgba(255,255,255,.5)}.wl-price-val{font-size:2.5rem;font-weight:900;line-height:1;color:var(--ink);margin-block-end:12px}.wl-featured .wl-price-val{color:#fff}.wl-price-val span{font-size:13px;font-weight:600;color:var(--muted)}.wl-featured .wl-price-val span{color:rgba(255,255,255,.78)}.wl-featured .wl-price-note{background:rgba(255,255,255,.12);border-color:rgba(255,255,255,.26);color:#fff}.wl-price-features{list-style:none;margin:20px 0 28px;display:flex;flex-direction:column;gap:10px;flex:1}.wl-price-features li{font-size:13px;color:var(--ink);display:flex;align-items:center;gap:8px}.wl-featured .wl-price-features li{color:#fff}.wl-price-features li:before{content:'✓';color:var(--primary);font-weight:900}.wl-featured .wl-price-features li:before{color:#FDE68A}.wl-price-btn{width:100%;padding:12px;margin-block-start:auto}.wl-price-btn.wl-primary{background:#fff;color:var(--primary);box-shadow:0 10px 28px rgba(26,16,64,.16)}.wl-price-btn.wl-outline{background:#fff;color:var(--primary);border:1.5px solid #D4C3FF}
.wl-testimonial-stars{font-size:13px;margin-block-end:14px}.wl-testimonial-text{font-size:14px;line-height:1.85;margin-block-end:20px;font-style:italic}.wl-testimonial-author{display:flex;align-items:center;gap:12px}.wl-testimonial-avatar{width:44px;height:44px;border-radius:50%;background:linear-gradient(135deg,var(--primary),var(--primary-light));display:flex;align-items:center;justify-content:center;color:#fff;font-weight:900;flex-shrink:0}.wl-testimonial-name{font-size:13px;font-weight:900}.wl-testimonial-role{font-size:11px;color:var(--muted)}
.wl-cta{padding:96px 5%;background:linear-gradient(135deg,var(--primary-dark),var(--primary),var(--primary-light));text-align:center;color:#fff}.wl-cta h2{font-size:clamp(1.9rem,3.5vw,2.8rem);font-weight:900;margin-block-end:14px}.wl-cta p{color:rgba(255,255,255,.84);margin-block-end:34px}.wl-cta-btns{display:flex;justify-content:center;gap:14px;flex-wrap:wrap}.wl-btn-white{background:#fff;color:var(--primary);padding:14px 32px;border:none}.wl-btn-outline-white{background:transparent;color:#fff;border:2px solid rgba(255,255,255,.55);padding:13px 28px}
.wl-footer{background:#1A1040;padding:62px 5% 30px;color:rgba(255,255,255,.72)}.wl-footer-top{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:42px;margin-block-end:46px}.wl-footer-logo-text{color:#fff}.wl-footer-desc{font-size:13px;line-height:1.85;max-width:320px}.wl-footer-col h3{font-size:13px;font-weight:900;color:#fff;margin-block-end:16px}.wl-footer-col ul{list-style:none;display:flex;flex-direction:column;gap:10px}.wl-footer-col a{font-size:13px;color:rgba(255,255,255,.72)}.wl-footer-col a:hover{color:#fff}.wl-footer-bottom{border-block-start:1px solid rgba(255,255,255,.1);padding-block-start:24px;display:flex;align-items:center;justify-content:space-between;font-size:12px;flex-wrap:wrap;gap:12px}.wl-footer-social{display:flex;gap:10px}.wl-footer-social a{width:34px;height:34px;border-radius:10px;background:rgba(255,255,255,.08);display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.72)}.wl-footer-social a:hover{background:var(--primary);color:#fff}
.wl-freelance-doc{max-width:680px;margin:0 auto 28px;padding:14px 18px;display:flex;align-items:center;justify-content:center;gap:14px;direction:rtl;text-align:center;color:#fff;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.16);border-radius:12px;box-shadow:inset 0 1px 0 rgba(255,255,255,.08);transition:transform .2s,border-color .2s,background .2s}.wl-freelance-doc:hover{transform:translateY(-2px);border-color:rgba(45,212,191,.72);background:rgba(255,255,255,.1)}.wl-sbc-logo{width:52px;height:52px;flex:0 0 52px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#D1FAE5,#ECFEFF);border:1px solid rgba(45,212,191,.65);box-shadow:0 10px 26px rgba(20,184,166,.18)}.wl-sbc-logo span{font-family:Manrope,system-ui,sans-serif;font-size:13px;font-weight:900;letter-spacing:.5px;color:#065F46}.wl-freelance-doc-copy{font-size:14px;font-weight:800;line-height:1.8;color:rgba(255,255,255,.92)}.wl-freelance-doc-copy strong{direction:ltr;unicode-bidi:isolate;font-family:Manrope,system-ui,sans-serif;font-weight:900;color:#fff}.wl-sbc-name{font-size:11px;font-weight:900;white-space:nowrap;color:#99F6E4;background:rgba(20,184,166,.14);border:1px solid rgba(45,212,191,.25);border-radius:999px;padding:5px 10px}
.wl-wa-btn{position:fixed;inset-block-end:28px;inset-inline-start:24px;z-index:200;background:#25D366;color:#fff;border-radius:999px;padding:13px 16px;font-size:13px;font-weight:900;box-shadow:0 10px 26px rgba(37,211,102,.36)}.wl-fade-up{opacity:0;transform:translateY(30px);transition:all .7s cubic-bezier(.16,1,.3,1)}.wl-fade-up.wl-visible{opacity:1;transform:translateY(0)}
.wl-stats,.wl-section,.wl-cta,.wl-footer{content-visibility:auto;contain-intrinsic-block-size:auto 720px}
@media(prefers-reduced-motion:reduce){.wl-landing *{scroll-behavior:auto!important;animation-duration:.01ms!important;animation-iteration-count:1!important;transition-duration:.01ms!important}}
@media(max-width:940px){.wl-nav-links,.wl-nav-cta,.wl-nav-login{display:none}.wl-mobile-menu .wl-nav-login,.wl-mobile-menu .wl-nav-cta{display:inline-flex}.wl-hamburger{display:flex}.wl-hero-inner{grid-template-columns:1fr;text-align:center}.wl-hero-sub{margin-inline:auto}.wl-hero-btns,.wl-hero-trust{justify-content:center}.wl-hero-visual{display:none}.wl-stats-inner{grid-template-columns:repeat(2,1fr)}.wl-stat+.wl-stat{border-inline-start:none}.wl-grid-3,.wl-steps{grid-template-columns:1fr}.wl-grid-4{grid-template-columns:repeat(2,1fr)}.wl-footer-top{grid-template-columns:1fr 1fr}.wl-footer-bottom{flex-direction:column;text-align:center}}
@media(max-width:620px){.wl-hero{padding-block-start:110px}.wl-btn-primary,.wl-btn-secondary,.wl-btn-white,.wl-btn-outline-white{width:100%}.wl-hero-btns,.wl-cta-btns{flex-direction:column}.wl-grid-4,.wl-stats-inner,.wl-footer-top{grid-template-columns:1fr}}
@media(max-width:620px){.wl-freelance-doc{flex-direction:column;padding:16px 14px;margin-block-end:24px}.wl-freelance-doc-copy{font-size:13px}.wl-sbc-name{white-space:normal}}
`;

function useLandingEffects() {
  const [scrolled, setScrolled] = useState(false);
  const lastScrolled = useRef(false);

  useEffect(() => {
    let scrollFrame = 0;
    let revealFrame = 0;

    const commitScrollState = () => {
      scrollFrame = 0;
      const nextScrolled = window.scrollY > 20;
      if (nextScrolled !== lastScrolled.current) {
        lastScrolled.current = nextScrolled;
        setScrolled(nextScrolled);
      }
    };

    const onScroll = () => {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(commitScrollState);
    };

    commitScrollState();

    const observer = new IntersectionObserver((entries) => {
      const visibleTargets = entries.filter((entry) => entry.isIntersecting).map((entry) => entry.target);
      if (!visibleTargets.length) return;

      if (revealFrame) window.cancelAnimationFrame(revealFrame);
      revealFrame = window.requestAnimationFrame(() => {
        visibleTargets.forEach((target) => {
          target.classList.add('wl-visible');
          observer.unobserve(target);
        });
        revealFrame = 0;
      });
    }, { threshold: 0.15 });

    const targets = Array.from(document.querySelectorAll('.wl-fade-up'));
    targets.forEach((el) => observer.observe(el));
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      if (revealFrame) window.cancelAnimationFrame(revealFrame);
      observer.disconnect();
    };
  }, []);

  return { scrolled };
}

function useLandingLanguage() {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return defaultLandingLocale;
    return localStorage.getItem('wafaa-landing-lang') || defaultLandingLocale;
  });

  useEffect(() => {
    localStorage.setItem('wafaa-landing-lang', lang);
    document.documentElement.lang = landingLocales[lang].lang;
    document.documentElement.dir = landingLocales[lang].dir;
  }, [lang]);

  return {
    lang,
    setLang,
    t: landingLocales[lang] || landingLocales[defaultLandingLocale],
  };
}

function formatNumber(value, lang) {
  return new Intl.NumberFormat(lang === 'ar' ? 'ar-SA' : 'en-US').format(Number(value) || 0);
}

function SectionHeader({ label, title, subtitle }) {
  return (
    <>
      <div className="wl-section-label">{label}</div>
      <h2 className="wl-section-title">{title}</h2>
      <p className="wl-section-sub">{subtitle}</p>
    </>
  );
}

export default function Landing() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [billingAnnual, setBillingAnnual] = useState(false);
  const { scrolled } = useLandingEffects();
  const { lang, setLang, t } = useLandingLanguage();
  const isLoggedIn = typeof window !== 'undefined' && Boolean(localStorage.getItem('token'));
  const dashboardOrRegister = isLoggedIn ? '/dashboard' : '/register';
  const accountHref = isLoggedIn ? '/dashboard' : '/login';
  const accountLabel = isLoggedIn ? t.nav.dashboard : t.nav.subscriberLogin;
  const nextLang = lang === 'ar' ? 'en' : 'ar';
  const pricingSectionHref = '#pricing-section';

  const scrollToPricingSection = (event) => {
    const pricingSection = document.getElementById('pricing-section');

    if (!pricingSection) return;

    event.preventDefault();
    pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.pushState(null, '', pricingSectionHref);
  };

  const navLinks = useMemo(() => ([
    ['#features', t.nav.features],
    ['#card-types', t.nav.cardTypes],
    ['#industries', t.nav.industries],
    ['#how', t.nav.how],
    [pricingSectionHref, t.nav.pricing],
    ['#contact', t.nav.contact],
  ]), [pricingSectionHref, t]);

  const annualMultiplier = 0.9;

  return (
    <div className="wl-landing" dir={t.dir} lang={t.lang} style={{ fontFamily: t.fontFamily }}>
      <style>{styles}</style>
      <a className="skip-link" href="#main-content">{lang === 'ar' ? 'انتقل إلى المحتوى الرئيسي' : 'Skip to main content'}</a>

      <nav className={`wl-nav ${scrolled ? 'wl-scrolled' : ''}`} aria-label={lang === 'ar' ? 'التنقل الرئيسي' : 'Primary navigation'}>
        <Link to="/" className="wl-nav-logo" aria-label={t.brand.name}>
          <div className="wl-nav-logo-icon"><BrandMark className="wl-brand-mark" /></div>
          <div className="wl-nav-logo-text">{t.brand.name}<span>{t.brand.mark}</span></div>
        </Link>

        <ul className="wl-nav-links">
          {navLinks.map(([href, label]) => <li key={href}><a href={href}>{label}</a></li>)}
        </ul>

        <div className="wl-nav-actions">
          <button className="wl-lang-switch" type="button" onClick={() => setLang(nextLang)}>
            {t.switchTo}
          </button>
          <Link to={accountHref} className="wl-nav-login">{accountLabel}</Link>
          <Link to={dashboardOrRegister} className="wl-nav-cta">{isLoggedIn ? t.nav.dashboard : t.nav.cta}</Link>
          <button className="wl-hamburger" type="button" aria-label={t.nav.menu} aria-expanded={menuOpen} aria-controls="mobile-navigation" onClick={() => setMenuOpen((open) => !open)}>
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <nav className={`wl-mobile-menu ${menuOpen ? 'wl-open' : ''}`} id="mobile-navigation" aria-label={lang === 'ar' ? 'التنقل على الجوال' : 'Mobile navigation'}>
        {navLinks.map(([href, label]) => (
          <a href={href} key={href} onClick={() => setMenuOpen(false)}>{label}</a>
        ))}
        <div className="wl-mobile-menu-actions">
          <button className="wl-lang-switch" type="button" onClick={() => setLang(nextLang)}>
            {t.switchTo}
          </button>
          <Link to={accountHref} className="wl-nav-login" onClick={() => setMenuOpen(false)}>{accountLabel}</Link>
          {!isLoggedIn && <Link to="/register" className="wl-nav-cta" onClick={() => setMenuOpen(false)}>{t.nav.cta}</Link>}
        </div>
      </nav>

      <main id="main-content" tabIndex="-1">
      <section className="wl-hero" aria-labelledby="landing-title">
        <div className="wl-container wl-hero-inner">
          <div>
            <div className="wl-hero-badge">{t.hero.badge}</div>
            <h1 id="landing-title">{t.hero.titlePrefix} <span>{t.hero.titleHighlight}</span></h1>
            <p className="wl-hero-sub">{t.hero.subtitle}</p>
            <div className="wl-hero-btns">
              <a href={pricingSectionHref} className="wl-btn-primary" onClick={scrollToPricingSection}>{t.hero.primaryCta}</a>
              <a href="#how" className="wl-btn-secondary">{t.hero.secondaryCta}</a>
              <Link to={accountHref} className="wl-btn-secondary">{accountLabel}</Link>
            </div>
            <div className="wl-hero-trust">
              <span className="wl-stars">★★★★★</span>
              <span>{t.hero.trust}</span>
            </div>
          </div>

          <div className="wl-hero-visual">
            <div className="wl-float-badge wl-top"><div className="wl-dot" />{t.hero.floatingTop}</div>
            <div className="wl-mockup">
              <div className="wl-mockup-bar">
                <div className="wl-mockup-dot" style={{ background: '#EF4444' }} />
                <div className="wl-mockup-dot" style={{ background: '#F59E0B' }} />
                <div className="wl-mockup-dot" style={{ background: '#10B981' }} />
              </div>

              <div className="wl-mockup-metrics">
                {t.mockup.metrics.map(([value, label]) => (
                  <div className="wl-mockup-metric" key={label}>
                    <div className="wl-mockup-metric-val">{value}</div>
                    <div className="wl-mockup-metric-label">{label}</div>
                  </div>
                ))}
              </div>

              <div className="wl-mockup-chart">
                <div style={{ fontSize: 11, color: '#7B6F9E', marginBottom: 8, fontWeight: 900 }}>{t.mockup.chartTitle}</div>
                <div className="wl-chart-bars">
                  {[35, 50, 45, 65, 55, 75, 90].map((height, index) => (
                    <div key={`${height}-${index}`} className={`wl-chart-bar ${index === 6 ? 'wl-active' : ''}`} style={{ height: `${height}%` }} />
                  ))}
                </div>
              </div>

              <div className="wl-mockup-card">
                <div className="wl-mockup-card-name">{t.mockup.store}</div>
                <div className="wl-mockup-card-title">{t.mockup.card}</div>
                <div className="wl-mockup-stamps">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <div key={index} className={`wl-mockup-stamp ${index < 5 ? 'wl-filled' : ''}`} />
                  ))}
                </div>
              </div>
            </div>
            <div className="wl-float-badge wl-bottom">🎉 {t.hero.floatingBottom}</div>
          </div>
        </div>
      </section>

      <section className="wl-stats">
        <div className="wl-container wl-stats-inner">
          {t.stats.map(([value, label]) => (
            <div className="wl-stat wl-fade-up" key={label}>
              <div className="wl-stat-val">{value}</div>
              <div className="wl-stat-label">{label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="wl-section" id="features">
        <div className="wl-container">
          <SectionHeader {...t.featuresSection} />
          <div className="wl-grid-3">
            {t.featuresSection.items.map((feature) => (
              <div className="wl-feature-card wl-fade-up" key={feature.title}>
                <div className="wl-feature-icon">{feature.icon}</div>
                <h3 className="wl-feature-title">{feature.title}</h3>
                <div className="wl-feature-desc">{feature.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wl-section wl-section-soft" id="card-types">
        <div className="wl-container">
          <SectionHeader {...t.cardTypes} />
          <div className="wl-grid-3">
            {t.cardTypes.items.map((program) => (
              <div className="wl-card-type wl-fade-up" key={program.title}>
                <div className="wl-card-type-badge">{program.badge}</div>
                <div className="wl-card-type-icon" style={{ background: program.background }}>{program.icon}</div>
                <h3 className="wl-card-type-title">{program.title}</h3>
                <div className="wl-card-type-desc">{program.desc}</div>
                <div className="wl-card-type-example">{program.example}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wl-section" id="industries">
        <div className="wl-container">
          <SectionHeader {...t.industries} />
          <div className="wl-grid-4">
            {t.industries.items.map(([icon, name, hint]) => (
              <div className="wl-industry-card wl-fade-up" key={name}>
                <div className="wl-industry-icon">{icon}</div>
                <h3 className="wl-industry-name">{name}</h3>
                <div className="wl-industry-hint">{hint}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wl-section wl-section-soft" id="how">
        <div className="wl-container">
          <SectionHeader {...t.how} />
          <div className="wl-steps">
            {t.how.steps.map(([icon, title, desc]) => (
              <div className="wl-step wl-fade-up" key={title}>
                <div className="wl-step-num">{icon}</div>
                <h3 className="wl-step-title">{title}</h3>
                <div className="wl-step-desc">{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wl-section bg-white" id="pricing-section">
        <div className="wl-container max-w-6xl">
          <SectionHeader {...t.pricing} />
          <div className="wl-billing-toggle">
            <button type="button" className={`wl-billing-label ${!billingAnnual ? 'wl-billing-active' : ''}`} onClick={() => setBillingAnnual(false)}>{t.pricing.monthly}</button>
            <button type="button" className={`wl-toggle-switch ${billingAnnual ? 'wl-on' : ''}`} onClick={() => setBillingAnnual((value) => !value)} role="switch" aria-checked={billingAnnual} aria-label={`${t.pricing.monthly} / ${t.pricing.annual}`} />
            <button type="button" className={`wl-billing-label ${billingAnnual ? 'wl-billing-active' : ''}`} onClick={() => setBillingAnnual(true)}>{t.pricing.annual}</button>
            <span className="wl-billing-save-badge">{t.pricing.save}</span>
          </div>

          <div className="wl-grid-3 items-stretch">
            {t.pricing.plans.map((plan) => {
              const annualBasePrice = plan.annualBasePrice || plan.originalPrice || plan.price;
              const displayedPrice = billingAnnual ? Math.round(annualBasePrice * annualMultiplier) : plan.price;
              const annualTotal = displayedPrice * 12;
              const priceText = formatNumber(displayedPrice, lang);
              const oldPriceText = formatNumber(billingAnnual ? annualBasePrice : plan.originalPrice, lang);
              const note = billingAnnual
                ? t.pricing.annualNote(priceText, formatNumber(annualTotal, lang))
                : plan.launchOffer || plan.note;

              return (
                <div className={`wl-price-card wl-fade-up rounded-2xl border p-7 shadow-sm ${plan.featured ? 'wl-featured ring-4 ring-wafaa-100' : 'bg-white'}`} key={plan.name}>
                  {plan.featured && <div className="wl-price-popular">{t.pricing.popular}</div>}
                  <div className="wl-price-name">{plan.name}</div>
                  <div className="wl-price-desc">{plan.desc}</div>
                  <div className="wl-price-was">{(billingAnnual || plan.originalPrice) ? `${oldPriceText} ${t.pricing.month}` : ''}</div>
                  <div className="wl-price-val">{priceText} <span>{billingAnnual ? t.pricing.annualMonth : t.pricing.month}</span></div>
                  <div className="wl-price-note">{note}</div>
                  <ul className="wl-price-features">
                    {plan.items.map((item) => <li key={item}>{item}</li>)}
                  </ul>
                  <Link to={dashboardOrRegister} className={`wl-price-btn ${plan.featured ? 'wl-primary' : 'wl-outline'}`}>{t.pricing.trialCta}</Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="wl-cta">
        <h2>{t.cta.title}</h2>
        <p>{t.cta.subtitle}</p>
        <div className="wl-cta-btns">
          <Link to={dashboardOrRegister} className="wl-btn-white">{t.cta.primary}</Link>
          <a href="#contact" className="wl-btn-outline-white">{t.cta.secondary}</a>
        </div>
      </section>
      </main>

      <footer className="wl-footer" id="contact">
        <div className="wl-container">
          <div className="wl-footer-top">
            <div>
              <div className="wl-footer-logo">
                <div className="wl-footer-logo-icon"><BrandMark className="wl-brand-mark" /></div>
                <div className="wl-footer-logo-text">{t.brand.name}</div>
              </div>
              <p className="wl-footer-desc">{t.footer.desc}</p>
            </div>

            <div className="wl-footer-col">
              <h3>{t.footer.platform}</h3>
              <ul>
                <li><a href="#features">{t.footer.links.features}</a></li>
                <li><a href="#how">{t.footer.links.how}</a></li>
                <li><a href={pricingSectionHref}>{t.footer.links.pricing}</a></li>
                <li><Link to="/register">{t.footer.links.register}</Link></li>
              </ul>
            </div>

            <div className="wl-footer-col">
              <h3>{t.footer.support}</h3>
              <ul>
                <li><a href="#how">{t.footer.links.guide}</a></li>
                <li><a href="https://wa.me/966553525634" target="_blank" rel="noreferrer">{t.footer.links.whatsapp}</a></li>
                <li><a href="mailto:hello@wafasa.net">{t.footer.links.email}</a></li>
              </ul>
            </div>

            <div className="wl-footer-col">
              <h3>{t.footer.legal}</h3>
              <ul>
                <li><Link to="/privacy">{t.footer.links.privacy}</Link></li>
                <li><Link to="/terms">{t.footer.links.terms}</Link></li>
                <li><Link to="/refund">{t.footer.links.refund}</Link></li>
              </ul>
            </div>
          </div>

          <a
            className="wl-freelance-doc"
            href={FREELANCE_DOCUMENT_VERIFICATION_URL}
            target="_blank"
            rel="noreferrer"
            dir="rtl"
            lang="ar"
            aria-label="التحقق من رقم وثيقة العمل الحر"
          >
            <span className="wl-sbc-logo" aria-hidden="true">
              <span>SBC</span>
            </span>
            <span className="wl-freelance-doc-copy">
              رقم وثيقة العمل الحر: [<strong dir="ltr">{FREELANCE_DOCUMENT_NUMBER}</strong>]
            </span>
            <span className="wl-sbc-name">المركز السعودي للأعمال</span>
          </a>

          <div className="wl-footer-bottom">
            <span>{t.footer.copyright}</span>
            <div className="wl-footer-social">
              <a href="https://x.com" target="_blank" rel="noreferrer">X</a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">IG</a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer">in</a>
              <a href="https://wa.me/966553525634" target="_blank" rel="noreferrer">WA</a>
            </div>
          </div>
        </div>
      </footer>

      <a href="https://wa.me/966553525634" className="wl-wa-btn" target="_blank" rel="noreferrer" aria-label={t.footer.whatsappLabel}>
        {t.footer.whatsappShort}
      </a>
    </div>
  );
}
